export default __webpack_public_path__ + "static/char-s-55-zh-Hant-2e6616e1a51114fc1e5038bf18fd8ed0.png";